import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { PackageIcon, CheckCircle2Icon, BrainIcon, ActivityIcon, ClipboardListIcon, UsersIcon, FileTextIcon, TrendingUpIcon } from 'lucide-react';
export function IncludesSection() {
  return <section className="py-20 bg-white" data-id="element-41">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-3" data-id="element-44">
            <span className="text-4xl" data-id="element-45">📦</span> ¿QUÉ INCLUYE?
          </h2>
          <h3 className="text-xl md:text-2xl font-bold text-[#1B3A5C] mb-6" data-id="element-46">
            72 SESIONES ORGANIZADAS EN 3 RAMAS CLÍNICAS
          </h3>
          <div className="w-24 h-1 bg-[#C9A84C] mx-auto rounded-full mb-8" data-id="element-47" />
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-48">
            Esta es la parte que hace diferente a este sistema de cualquier
            banco de actividades del mercado.
            <br data-id="element-49" />
            <br data-id="element-50" />
            No es una sola versión genérica de sesiones. Son{' '}
            <span className="font-bold text-gray-900" data-id="element-51">
              tres versiones completas
            </span>{' '}
            del mismo programa, diseñadas para tres perfiles clínicos reales con
            los que trabajás todos los días:
          </p>
        </motion.div>

        {/* 3 Branches Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-20" data-id="element-52">
          {/* Rama A */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-green-50 rounded-2xl p-8 border border-green-100 shadow-sm relative overflow-hidden" data-id="element-53">
            <div className="absolute top-0 right-0 w-32 h-32 bg-green-200 rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-54" />
            <div className="relative z-10" data-id="element-55">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-green-100 text-green-700 rounded-xl mb-6" data-id="element-56">
                <UsersIcon className="w-6 h-6" data-id="element-57" />
              </div>
              <h4 className="text-xl font-bold text-green-900 mb-2" data-id="element-58">
                🟢 RAMA A — PACIENTES NEUROTÍPICOS
              </h4>
              <p className="text-green-800 font-medium mb-6" data-id="element-59">
                24 sesiones de intervención fonoaudiológica con progresión
                pedagógica real.
              </p>
              <ul className="space-y-3" data-id="element-60">
                {['Objetivo clínico', '3 actividades autocontenidas', 'Registro clínico', 'Tarea para casa', 'Pensada para niños de 4 a 12 años', 'Lista para imprimir y aplicar'].map((item, i) => <li key={i} className="flex items-start gap-2 text-green-900 text-sm" data-id="element-61">
                    <CheckCircle2Icon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-62" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Rama B */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-blue-50 rounded-2xl p-8 border border-blue-100 shadow-sm relative overflow-hidden" data-id="element-63">
            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-200 rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-64" />
            <div className="relative z-10" data-id="element-65">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 text-blue-700 rounded-xl mb-6" data-id="element-66">
                <ActivityIcon className="w-6 h-6" data-id="element-67" />
              </div>
              <h4 className="text-xl font-bold text-blue-900 mb-2" data-id="element-68">
                🔵 RAMA B — PACIENTES CON TDAH
              </h4>
              <p className="text-blue-800 font-medium mb-6" data-id="element-69">
                Las mismas 24 sesiones adaptadas para el perfil atencional real
                del TDAH.
              </p>
              <p className="text-sm font-bold text-blue-900 mb-3" data-id="element-70">
                Cada ficha tiene:
              </p>
              <ul className="space-y-3 mb-6" data-id="element-71">
                {['Instrucciones cortas y segmentadas (una a la vez)', 'Checklist visual para que el niño se autorregule solo', 'Pausas activas integradas entre cada actividad', 'Desafíos cronometrados que sostienen el foco', 'Semáforo interior como herramienta de control inhibitorio', 'Refuerzo positivo inmediato integrado en la estructura'].map((item, i) => <li key={i} className="flex items-start gap-2 text-blue-900 text-sm" data-id="element-72">
                    <CheckCircle2Icon className="w-5 h-5 text-blue-600 flex-shrink-0" data-id="element-73" />
                    {item}
                  </li>)}
              </ul>
              <div className="bg-white/60 p-4 rounded-lg text-sm text-blue-900 font-medium border border-blue-100" data-id="element-74">
                No es la misma sesión con menos texto. Es una arquitectura
                diferente pensada para cómo funciona el cerebro con TDAH.
              </div>
            </div>
          </motion.div>

          {/* Rama C */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-purple-50 rounded-2xl p-8 border border-purple-100 shadow-sm relative overflow-hidden" data-id="element-75">
            <div className="absolute top-0 right-0 w-32 h-32 bg-purple-200 rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-76" />
            <div className="relative z-10" data-id="element-77">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-purple-100 text-purple-700 rounded-xl mb-6" data-id="element-78">
                <BrainIcon className="w-6 h-6" data-id="element-79" />
              </div>
              <h4 className="text-xl font-bold text-purple-900 mb-2" data-id="element-80">
                🟣 RAMA C — PACIENTES CON TEA
              </h4>
              <p className="text-purple-800 font-medium mb-6" data-id="element-81">
                Las mismas 24 sesiones adaptadas para el perfil del espectro
                autista.
              </p>
              <p className="text-sm font-bold text-purple-900 mb-3" data-id="element-82">
                Cada ficha tiene:
              </p>
              <ul className="space-y-3 mb-6" data-id="element-83">
                {['Cronograma visual de sesión (PRIMERO-DESPUÉS-LUEGO)', 'Instrucciones literales de un solo paso', 'Tareas de emparejamiento y clasificación como formato primario', 'Baja saturación visual: un estímulo a la vez', 'Cierre predecible y ritual de sesión consistente', 'Herramientas visuales permanentes: tabla de colores, semáforo de comunicación, organizador de cuentos, tabla de conectores'].map((item, i) => <li key={i} className="flex items-start gap-2 text-purple-900 text-sm" data-id="element-84">
                    <CheckCircle2Icon className="w-5 h-5 text-purple-600 flex-shrink-0" data-id="element-85" />
                    {item}
                  </li>)}
              </ul>
              <div className="bg-white/60 p-4 rounded-lg text-sm text-purple-900 font-medium border border-purple-100" data-id="element-86">
                No es una adaptación superficial. Es un sistema clínico
                construido desde la lógica del procesamiento TEA.
              </div>
            </div>
          </motion.div>
        </div>

        {/* Session Components Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-87">
          <h3 className="text-2xl font-bold text-center text-gray-900 mb-8" data-id="element-88">
            CADA SESIÓN DE LAS 72 INCLUYE:
          </h3>

          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-89">
            <div className="overflow-x-auto" data-id="element-90">
              <table className="w-full text-left border-collapse" data-id="element-91">
                <thead data-id="element-92">
                  <tr className="bg-[#1B3A5C] text-white" data-id="element-93">
                    <th className="p-4 font-bold w-1/3" data-id="element-94">Componente</th>
                    <th className="p-4 font-bold w-2/3" data-id="element-95">¿Qué es?</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100" data-id="element-96">
                  <tr className="hover:bg-gray-50 transition-colors" data-id="element-97">
                    <td className="p-4 font-bold text-gray-900 flex items-center gap-2" data-id="element-98">
                      <ClipboardListIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-99" />
                      Ficha 1 — Guía del profesional
                    </td>
                    <td className="p-4 text-gray-600" data-id="element-100">
                      Objetivo clínico, tiempo, materiales, qué observar y cómo
                      arrancar
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50 transition-colors" data-id="element-101">
                    <td className="p-4 font-bold text-gray-900 flex items-center gap-2" data-id="element-102">
                      <ActivityIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-103" />
                      Ficha 2 — Actividad de apertura
                    </td>
                    <td className="p-4 text-gray-600" data-id="element-104">
                      15 minutos de actividad lista para aplicar
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50 transition-colors" data-id="element-105">
                    <td className="p-4 font-bold text-gray-900 flex items-center gap-2" data-id="element-106">
                      <ActivityIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-107" />
                      Ficha 3 — Actividad de desarrollo
                    </td>
                    <td className="p-4 text-gray-600" data-id="element-108">
                      15 minutos de actividad lista para aplicar
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50 transition-colors" data-id="element-109">
                    <td className="p-4 font-bold text-gray-900 flex items-center gap-2" data-id="element-110">
                      <ActivityIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-111" />
                      Ficha 4 — Actividad de cierre
                    </td>
                    <td className="p-4 text-gray-600" data-id="element-112">
                      15 minutos de actividad lista para aplicar
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50 transition-colors" data-id="element-113">
                    <td className="p-4 font-bold text-gray-900 flex items-center gap-2" data-id="element-114">
                      <FileTextIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-115" />
                      Ficha 5 — Registro para la familia
                    </td>
                    <td className="p-4 text-gray-600" data-id="element-116">
                      Resumen de la sesión, observaciones y tarea para casa
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="bg-gray-50 p-4 text-center border-t border-gray-100" data-id="element-117">
              <p className="font-bold text-[#1B3A5C]" data-id="element-118">
                Nada suelto. Nada al azar. 45 minutos de sesión completamente
                cubiertos.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Clinical Progression */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#EDF2F7] rounded-3xl p-8 md:p-12 border border-blue-100" data-id="element-119">
          <div className="text-center mb-10" data-id="element-120">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-6 shadow-sm" data-id="element-121">
              <TrendingUpIcon className="w-8 h-8 text-[#C9A84C]" data-id="element-122" />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-123">
              LA PROGRESIÓN CLÍNICA DE LAS 72 SESIONES
            </h3>
            <p className="text-lg text-gray-600" data-id="element-124">
              Cada rama recorre 6 bloques de trabajo en la misma secuencia:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-125">
            {[{
            title: 'Bloque I',
            desc: 'Evaluación y vínculo'
          }, {
            title: 'Bloque II',
            desc: 'Conciencia fonológica'
          }, {
            title: 'Bloque III',
            desc: 'Asociación fonema-grafema'
          }, {
            title: 'Bloque IV',
            desc: 'Comprensión del lenguaje'
          }, {
            title: 'Bloque V',
            desc: 'Expresión y producción'
          }, {
            title: 'Bloque VI',
            desc: 'Consolidación y cierre con diploma'
          }].map((block, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-[#1B3A5C]" data-id="element-126">
                <p className="text-sm font-bold text-[#C9A84C] mb-1 uppercase tracking-wider" data-id="element-127">
                  {block.title}
                </p>
                <p className="text-lg font-bold text-gray-900" data-id="element-128">{block.desc}</p>
              </div>)}
          </div>

          <div className="text-center" data-id="element-129">
            <p className="text-xl font-bold text-[#1B3A5C] bg-white inline-block px-8 py-4 rounded-full shadow-sm" data-id="element-130">
              El niño no solo trabaja contenidos. Avanza por etapas clínicas con
              evidencia de progreso en cada una.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}